import React from 'react';

const PageNotFound: React.FC = () => {
  return (
    <div className="h-screen flex flex-col overflow-hidden"
      style={{
          background: '#FBFBFB',
        }}>
      {/* Header */}
      <header
        className="p-6 md:py-4 md:px-[120px]"
        style={{
          borderBottom: '0.5px solid var(--color-beige, #EEEDEC)',
          background: '#FFF',
        }}
      >
        <img
          src="/images/mic-logo.png"
          alt="MIC Logo"
          width={104}
          height={50}
        />
      </header>

      {/* Main Content */}
      <div
        className="flex-1 flex min-h-0 m-6 md:my-8 md:mx-[112px]"
        style={{
          border: '1px solid #F3F4F6',
          borderRadius: '8px',
          overflow: 'hidden',
          background: '#FFF',
        }}
      >
        {/* Column 1 - Text Content */}
        <div className="flex-1 relative">
          <div
            style={{
              position: 'absolute',
              bottom: '60px',
              left: '40px',
              background: 'rgba(0, 0, 0, 0.00)',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
            }}
          >
            <span
              style={{
                color: 'var(--color-charcoal, #63615C)',
                fontFamily: 'Interstate',
                fontSize: '80px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: 'normal',
                letterSpacing: '0.6px',
                opacity: 0.2,
              }}
            >
              404
            </span>
            <span
              style={{
                color: 'var(--color-charcoal, #63615C)',
                fontFamily: 'Interstate',
                fontSize: '32px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: 'normal',
                letterSpacing: '0.6px',
              }}
            >
              Page Not Found
            </span>
            <span
              style={{
                color: 'var(--color-charcoal, #63615C)',
                fontFamily: 'Interstate',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: 'normal',
                letterSpacing: '0.6px',
                paddingRight: '8px'
              }}
            >
              The page you are looking for doesn't exist or has been removed.
            </span>
          </div>
        </div>

        {/* Column 2 - Image */}
        <div className="hidden md:flex flex-1">
          <img
            src="/images/background-404.png"
            alt="404 Background"
            className="w-full h-full object-cover grayscale"
          />
        </div>
      </div>

      {/* Footer */}
      <footer
        className="py-6 px-6 md:px-[120px]"
        style={{
          height: '80px',
          borderTop: '1px solid #F3F4F6',
        }}
      >
        <span
          style={{
            color: '#9CA3AF',
            fontFamily: 'Interstate',
            fontSize: '12.014px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '16px',
          }}
        >
          ©{new Date().getFullYear()} Mubadala Investment Company. Internal use only.
        </span>
      </footer>
    </div>
  );
};

export default PageNotFound;
